import { writeSkinWeights } from './weights';

/** Matches MeshVertex: position/normal/uv, packed skin, face frame, local UV repair. */
export const MESH_VERTEX_STRIDE = 68;

export function packVerts(pos: ArrayLike<number>, nrm: ArrayLike<number>, uv: ArrayLike<number>, joints: ArrayLike<number> | null, weights: ArrayLike<number> | null, aux: ArrayLike<number> | null = null, repair: ArrayLike<number> | null = null): ArrayBuffer {
  const count = pos.length / 3;
  if (!Number.isInteger(count) || nrm.length !== pos.length || uv.length !== count * 2 ||
    (joints && joints.length !== count * 4) || (weights && weights.length !== count * 4) ||
    (aux && aux.length !== count * 4) || (repair && repair.length !== count * 3)) throw new Error('Invalid character vertex attribute lengths');
  const buffer = new ArrayBuffer(count * MESH_VERTEX_STRIDE), floats = new Float32Array(buffer), bytes = new Uint8Array(buffer);
  for (let i = 0; i < count; i++) {
    const f = i * MESH_VERTEX_STRIDE / 4, b = i * MESH_VERTEX_STRIDE + 32;
    for (let k = 0; k < 3; k++) { floats[f + k] = pos[i * 3 + k]; floats[f + 3 + k] = nrm[i * 3 + k]; floats[f + 14 + k] = repair?.[i * 3 + k] ?? 0; }
    floats[f + 6] = uv[i * 2]; floats[f + 7] = uv[i * 2 + 1];
    for (let k = 0; k < 4; k++) { bytes[b + k] = joints?.[i * 4 + k] ?? 0; floats[f + 10 + k] = aux?.[i * 4 + k] ?? (k === 2 ? -1 : k === 3 ? -9 : 0); }
    writeSkinWeights(weights, i * 4, bytes, b + 4);
  }
  return buffer;
}
